import Layout from '../views/layout/layout.vue'
/* 需要权限判断的路由 */
const dynamicRoutes = [
	{
		path: '/customers',
		component: Layout,
		name: 'customers',
		meta: {
			name: '客户管理',
			icon: 'customers'
		},
		children: [
			{
				path: 'customer',
				name: 'customer',
				component: () => import("../views/customers/customer.vue"),
				meta: {
					name: '客户管理',
					icon: ''
				}
			},
		]
	},
	{
		path: '/basicSets',
		component: Layout,
		name: 'basicSets',
		meta: {
			name: '基本设置',
			icon: 'basicSets'
		},
		children: [
			{
				path: 'company',
				name: 'company',
				component: () => import("../views/basicSets/company.vue"),
				meta: {
					name: '公司管理',
					icon: 'table'
				}
			},
			{
				path: 'operator',
				name: 'operator',
				component: () => import("../views/basicSets/operator.vue"),
				meta: {
					name: '操作员管理',
					icon: 'user'
				},
			},{
				path: 'salesman',
				name: 'salesman',
				component: () => import("../views/basicSets/salesman.vue"),
				meta: {
					name: '业务员管理',
					icon: 'user'
				},
			},{
				path: 'rolePermission',
				name: 'rolePermission',
				component: () => import("../views/basicSets/rolePermission.vue"),
				meta: {
					name: '角色权限配置',
					icon: 'user'
				},
			},{
				path: 'VIParameterConfig',
				name: 'VIParameterConfig',
				component: () => import("../views/basicSets/VIParameterConfig.vue"),
				meta: {
					name: 'VI参数配置',
					icon: 'user'
				},
			}
		]
	},
	{
		path: '/products',
		component: Layout,
		name: 'products',
		meta: {
			name: '货品管理',
			icon: 'products'
		},
		children: [
			{
				path: 'info',
				name: 'info',
				component: () => import("../views/products/info.vue"),
				meta: {
					name: '货品信息',
					icon: 'table'
				}
			},
			{
				path: 'classify',
				name: 'classify',
				component: () => import("../views/products/classify.vue"),
				meta: {
					name: '货品分类',
					icon: 'user'
				},
			},{
				path: 'brand',
				name: 'brand',
				component: () => import("../views/products/brand.vue"),
				meta: {
					name: '品牌管理',
					icon: 'user'
				},
			},{
				path: 'unit',
				name: 'unit',
				component: () => import("../views/products/unit.vue"),
				meta: {
					name: '计量单位管理',
					icon: 'user'
				},
			}  
		]
	},
	{
		path: '/warehouse',
		component: Layout,
		name: 'warehouse',
		meta: {
			name: '库房管理',
			icon: 'warehouse'
		},
		children: [
			// {
			// 	path: 'group',
			// 	name: 'group',
			// 	component: () => import("../views/warehouse/group.vue"),
			// 	meta: {
			// 		name: '库房分组',
			// 		icon: 'table'
			// 	}
			// },
			{
				path: 'storehouse',
				name: 'storehouse',
				component: () => import("../views/warehouse/storehouse.vue"),
				meta: {
					name: '库房',
					icon: 'user'
				},
			},{
				path: 'location',
				name: 'location',
				component: () => import("../views/warehouse/location.vue"),
				meta: {
					name: '货位',
					icon: 'user'
				},
			} 
		]
	},
	{
		path: '/outAndIn',
		component: Layout,
		name: 'outAndIn',
		meta: {
			name: '出入库管理',
			icon: 'outAndIn'
		},
		children: [
			{
				path: 'stockIn',
				name: 'stockIn',
				component: () => import("../views/outAndIn/stockIn.vue"),
				meta: {
					name: '入库',
					icon: 'table'
				}
			},
			{
				path: 'stockOut',
				name: 'stockOut',
				component: () => import("../views/outAndIn/stockOut.vue"),
				meta: {
					name: '出库',
					icon: 'user'
				},
			},{
				path: 'disassembly',
				name: 'disassembly',
				component: () => import("../views/outAndIn/disassembly.vue"),
				meta: {
					name: '拆卸单',
					icon: 'user'
				},
			},{
				path: 'assemble',
				name: 'assemble',
				component: () => import("../views/outAndIn/assemble.vue"),
				meta: {
					name: '组装单',
					icon: 'user'
				},
			},,{
				path: 'inventory',
				name: 'inventory',
				component: () => import("../views/outAndIn/inventory.vue"),
				meta: {
					name: '库存',
					icon: 'user'
				},
			} 
		]
	},
	{
		path: '/erp',
		component: Layout,
		name: 'erp',
		meta: {
			name: 'ERP对接',
			icon: 'erp'
		},
		children: [
			{
				path: 'waitForStockIn',
				name: 'waitForStockIn',
				component: () => import("../views/erp/waitForStockIn.vue"),
				meta: {
					name: '待入库',
					icon: 'table'
				}
			},
			{
				path: 'waitForStockOut',
				name: 'waitForStockOut',
				component: () => import("../views/erp/waitForStockOut.vue"),
				meta: {
					name: '待出库',
					icon: 'user'
				},
			},
			{
				path: 'waitForDisassembly',
				name: 'waitForDisassembly',
				component: () => import("../views/erp/waitForDisassembly.vue"),
				meta: {
					name: '待拆卸',
					icon: 'user'
				},
			},
			{
				path: 'waitForAssemble',
				name: 'waitForAssemble',
				component: () => import("../views/erp/waitForAssemble.vue"),
				meta: {
					name: '待组装',
					icon: 'user'
				},
			}
		]
	},
	{
		path: '/systemParam',
		component: Layout,
		name: 'systemParam',
		meta: {
			name: '系统参数管理',
			icon: 'systemParam'
		},
		children: [
			{
				path: 'stockType',
				name: 'stockType',
				component: () => import("../views/systemParam/stockType.vue"),
				meta: {
					name: '出入库类型',
					icon: 'table'
				}
			},
			{
				path: 'systemMenu',
				name: 'systemMenu',
				component: () => import("../views/systemParam/systemMenu.vue"),
				meta: {
					name: '系统菜单管理',
					icon: 'user'
				},
			},
			{
				path: 'systemLog',
				name: 'systemLog',
				component: () => import("../views/systemParam/systemLog.vue"),
				meta: {
					name: '系统日志管理',
					icon: 'user'
				},
			}
		]
	},
]

export default dynamicRoutes
